'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_iltotore_iron_RuntimeConstraint(_test, message) {
  this.zs = null;
  this.zt = null;
  this.zs = _test;
  this.zt = message;
}
export { $c_Lio_github_iltotore_iron_RuntimeConstraint as $c_Lio_github_iltotore_iron_RuntimeConstraint };
$p = $c_Lio_github_iltotore_iron_RuntimeConstraint.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lio_github_iltotore_iron_RuntimeConstraint;
/** @constructor */
function $h_Lio_github_iltotore_iron_RuntimeConstraint() {
}
export { $h_Lio_github_iltotore_iron_RuntimeConstraint as $h_Lio_github_iltotore_iron_RuntimeConstraint };
$h_Lio_github_iltotore_iron_RuntimeConstraint.prototype = $p;
var $d_Lio_github_iltotore_iron_RuntimeConstraint = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_iltotore_iron_RuntimeConstraint, "io.github.iltotore.iron.RuntimeConstraint", ({
  jx: 1
}));
export { $d_Lio_github_iltotore_iron_RuntimeConstraint as $d_Lio_github_iltotore_iron_RuntimeConstraint };
